/**
 * Customer-plane paths the person tier navigates to, in one place.
 *
 * Small on purpose: `EngagementChooser.tsx` and `DeepLinkResolver.tsx` both
 * need the chooser's path, and having the resolver import it from the screen
 * it forwards to would make one lazy-loaded chunk pull in the other's module
 * graph just to read a string.
 */
export const CHOOSER_PATH = '/engagements'

/** The owner's fork for one engagement (§6.2). */
export const ownerPathFor = (customerRef: string): string => `${CHOOSER_PATH}/${customerRef}`

/** Who You Are, confirm mode (§6.3). */
export const confirmPathFor = (customerRef: string): string =>
  `${CHOOSER_PATH}/${customerRef}/confirm`

/** Chapter delegation (§6.5). */
export const peoplePathFor = (customerRef: string): string =>
  `${CHOOSER_PATH}/${customerRef}/people`

/**
 * The service step (§6.4) and the non-assessment status view (§6.2) share one
 * path: both answer "what is this engagement for?", and which one renders is
 * decided by the engagement's own service line rather than by the URL.
 */
export const servicePathFor = (customerRef: string): string =>
  `${CHOOSER_PATH}/${customerRef}/service`
